module.exports = __webpack_public_path__ + "img/avion.cdaf465c.jpg";